import LegalInsuranceContact from '@/components/content/benefits/modals/legalInsurance/components/LegalInsuranceContact';
import { useKaeuferPlusLegalInsurance } from '@/customHooks/useKaeuferPlusLegalInsurance';
import { Msg } from '@/i18n';

const LegalInsuranceTerm = ({ startDate, endDate }: { startDate?: string; endDate?: string }) => (
  <div className='grid'>
    <div className='grid-item align-center'>
      <div className='one-whole'>
        <Msg id='benefits.legalInsurance.modal.details.startDate' defaultMessage='Start date' />
      </div>
      <h2 className={'one-whole font-heading-large-regular'}>{startDate}</h2>
    </div>
    <div className='grid-item align-center'>
      <div className='one-whole'>
        <Msg id='benefits.legalInsurance.modal.details.endDate' defaultMessage='End date' />
      </div>
      <h2 className={'one-whole font-heading-large-regular'}>{endDate}</h2>
    </div>
    <div className={'grid-item'}>
      <Msg
        id='benefits.legalInsurance.modal.details.explenatory'
        defaultMessage='Your ARAG neighborhood legal protection is activated...'
      />
    </div>
  </div>
);

const OverviewTab = () => {
  const { kaeuferPlusLegalInsuranceActivationDate, kaeuferPlusLegalInsuranceExpirationDate } =
    useKaeuferPlusLegalInsurance();
  return (
    <div className='grid vertical-padding-l'>
      <div className='grid-item desk-eight-tenths desk-push-one-tenth margin-bottom-l'>
        <div className='status-message status-confirm'>
          <div className='status-title'>
            <Msg
              id='benefits.legalInsurance.modal.details.active.title'
              defaultMessage='Legal insurance activated'
              values={{ palmBr: <br className='desk-hide lap-hide' /> }}
            />
          </div>
          <div>
            <Msg
              id='benefits.legalInsurance.modal.details.active.text'
              defaultMessage='Your ARAG legal insurance is activated.'
            />
          </div>
        </div>
      </div>
      <div className='grid-item one-whole desk-eight-tenths desk-push-one-tenth margin-top-s'>
        <div className='LegalInsuranceNumber align-center'>
          <div className='Header one-whole'>
            <Msg
              id='benefits.legalInsurance.modal.details.legalInsuranceNumberHeader'
              defaultMessage='Your legal insurance number...'
            />
          </div>
          <h2 className='one-whole font-heading-large-regular'>
            <Msg id='benefits.legalInsurance.modal.details.legalInsuranceNumber' defaultMessage='11008213767342' />
          </h2>
        </div>
      </div>
      <div className='grid-item one-whole desk-eight-tenths desk-push-one-tenth margin-top-s'>
        <LegalInsuranceTerm
          startDate={kaeuferPlusLegalInsuranceActivationDate}
          endDate={kaeuferPlusLegalInsuranceExpirationDate}
        />
      </div>
      <div className='grid-item one-whole desk-eight-tenths desk-push-one-tenth padding-top-xl'>
        <LegalInsuranceContact />
      </div>
    </div>
  );
};

export default OverviewTab;
